// @flow
import React from 'react'
import './styles.scss'
import { Waypoint } from 'react-waypoint'

const isMobile = window.innerWidth < 600

export class LonzaAreal extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      overlayed: false
    }
  }

  componentDidMount() {}

  render() {
    return (
      <div
        className={
          this.state.overlayed ? 'areal-wrapper overlayed' : 'areal-wrapper'
        }
      >
        <img
          className='ui image fluid label'
          src={require(isMobile
            ? '../../images/lonza-areal-label-mobile.png'
            : '../../images/lonza-areal-label.png')}
        />
        <img
          className='ui image fluid overlay'
          src={require(isMobile
            ? '../../images/lonza-areal-overlay-mobile.png'
            : '../../images/lonza-areal-overlay.png')}
        />
        <img
          className='ui image fluid photo'
          src={require(isMobile
            ? '../../images/lonza-areal-mobile.jpg'
            : '../../images/lonza-areal.jpg')}
        />
        <div className='ui container'>
          <figcaption className='ui container'>
            Die klimaschädlichste Fabrik der Schweiz: Die Fabrik D29 stösst
            jedes Jahr 1800 Tonnen Lachgas aus. Foto: Fabian Hugo
          </figcaption>
        </div>
        <Waypoint
          onEnter={event => {
            this.setState({ overlayed: true })
          }}
          onLeave={event => {
            this.setState({ overlayed: false })
          }}
        />
      </div>
    )
  }
}
